import useLoggedUser from '@/features/auth/hooks/useLoggedUser'
import useCurrentMarket from '@/features/caching/hooks/useCurrentMarket'
import { EnvironmentVariable } from '../store/environment-state'
import { useEnvironmentState } from '../store/useEnvironmentState'

export const useFeatureFlags = () => {
	const market = useCurrentMarket()
	const user = useLoggedUser()
	const environment = useEnvironmentState()

	return { isFeatureEnabled: (feature: EnvironmentVariable) => environment.isFeatureEnabled(feature, market, user) }
}
